<div class="condensed-short-header-wrapper">
  <!-- TITLE AND SUBTITLE -->
  <div class="title-subtitle">
    @if ((titleGroup?.fields)[0] != null) {
      @if (templateProjectionMap() != null && titleGroup.fields[0].options?.hasAnchor) {
        <ng-container
          [ngTemplateOutlet]="templateProjectionMap() | selectTemplateOutlet: 'miq-goes-to-record'"
        [ngTemplateOutletContext]="{
          classes: 'record-link',
          urlParams:
            reportRecordData()
            | reportFieldRouteFn: { templateId: currentView().templateId, field: (titleGroup?.fields)[0] },
          content: subtitleName,
        }"
          >
        </ng-container>
      } @else {
        <div class="title-subtitle__name">
          {{
          reportRecordData()
          | reportFieldFormatter
          : {
          templateId: currentView().templateId,
          field: (titleGroup?.fields)[0],
          joinString: true,
          onlyUrl: false,
        }
        | async
        }}
      </div>
    }
  }
  @if ((titleGroup?.fields)[1] != null) {
    @if (templateProjectionMap() != null && titleGroup.fields[1].options?.hasAnchor) {
      <ng-container
        [ngTemplateOutlet]="templateProjectionMap() | selectTemplateOutlet: 'miq-goes-to-record'"
        [ngTemplateOutletContext]="{
          classes: 'record-link',
          urlParams:
            reportRecordData()
            | reportFieldRouteFn: { templateId: currentView().templateId, field: (titleGroup?.fields)[1] },
          content: subtitleValue,
        }"
        >
      </ng-container>
    } @else {
      @if (
        reportRecordData() | isFieldVisible: { templateId: currentView().templateId, field: titleGroup?.fields[1] }
        ) {
        <div
          class="title-subtitle__address"
          >
          {{
          reportRecordData()
          | reportFieldFormatter
          : {
          templateId: currentView().templateId,
          field: (titleGroup?.fields)[1],
          joinString: true,
          onlyUrl: false,
        }
        | async
        }}
      </div>
    }
  }
}
</div>
<div class="properties-component">
  @if (attributesGroup && attributesGroup?.fields.length) {
    <ul>
      @for (field of attributesGroup.fields; track field) {
        <li [class]="field.class ? field.class : ''">
          @if (!!field.label) {
            <label [ngClass]="{ clickable: editableFieldsService.editableTemplateAttributes[field.id] }">{{
              field.label
            }}</label>
            <span [ngClass]="{ clickable: editableFieldsService.editableTemplateAttributes[field.id] }">
              {{
              reportRecordData()
              | reportFieldFormatter
              : {
              templateId: currentView().templateId,
              field: field,
              joinString: true,
              onlyUrl: false,
            }
            | async
            }}
          </span>
        } @else {
          <label [ngClass]="{ clickable: editableFieldsService.editableTemplateAttributes[field.id] }">{{
            reportRecordData()
            | reportFieldFormatter
            : {
            templateId: currentView().templateId,
            field: field,
            joinString: true,
            onlyUrl: false,
          }
          | async
        }}</label>
      }
    </li>
  }
</ul>
}
</div>
</div>
